import type { ShortCircuitScenarioResults } from '../../..';
import { AttentionStatusStorage2 } from '../../../evaluation/AttentionStatusRepository';
import type { ForRuleProviding } from '../../../evaluation/RulesProvider';
import { FaultCurrentEvaluationEngine } from '../../../evaluation/shortCircuit/engines/lowVoltage/faultCurrentEvaluationEngine';
import { evaluateEnergyConsumers } from '../../../evaluation/shortCircuit/summary/evaluateEnergyConsumers';
import type { LvShortCircuitSummaryEvaluatedResults } from './LvShortCircuitSummaryEvaluatedResults';

type GetLvShortCircuitSummary = (
  allScenarios: ShortCircuitScenarioResults[],
  rulesProvider: ForRuleProviding
) => LvShortCircuitSummaryEvaluatedResults;

export const getLvShortCircuitSummary: GetLvShortCircuitSummary = (
  allScenarios,
  rulesProvider
) => {
  const evaluationEngine = new FaultCurrentEvaluationEngine(
    AttentionStatusStorage2.noStorage(),
    rulesProvider
  );

  return evaluateEnergyConsumers(allScenarios, evaluationEngine);
};
